var React = require('react');

function Star (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"star","d":"M8 .867l2.318 4.696 5.182.753-3.75 3.655.885 5.162L8 12.696l-4.635 2.437.885-5.162L.5 6.316l5.182-.753z","style":{"fill":"rgb(245, 87, 0)","transition":"fill 0.2s ease-in-out 0s"}}));
}

Star.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = Star;

Star.default = Star;
